import React, { useEffect, useState } from 'react';
import * as AppPics from 'assets/images';
import { AppTextField, AppButton } from 'components';
import Joi from 'joi';
import { checkForErrors } from 'utilities/fns';
import { useHistory, useParams, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import AppBreadcrumbs from 'components/molecules/AppBreadcrumbs';
import useSupportTicket from 'hooks/API/POST/useSupportTicket';
import useGetOneSupportTicket from 'hooks/API/GET/useGetOneSupportTicket';

function ManageSupportTicket() {
  const { ticketId } = useParams();

  const history = useHistory();
  const location = useLocation();

  const params = new URLSearchParams(location.search);
  const redirectBack = params.get('redirect_back');

  const [disableSubmit, setDisableSubmit] = useState(false);
  const [adminReply, setAdminReply] = useState('');
  const [formErrors, setFormErrors] = useState([]);
  const [validationErrorServer, setValidationErrorServer] = useState({});

  const { data: ticket } = useGetOneSupportTicket({
    ticketId,
    enabled: true,
  });

  const ticketData = ticket?.data?.data?.ticket;
  const replies = ticket?.data?.data?.replies || [];

  const {
    mutate: sendReply,
    isLoading,
    isError,
    isSuccess,
    data: replyResponse,
    error,
  } = useSupportTicket();

  const handleGoBack = () => {
    if (redirectBack) {
      history.replace(decodeURIComponent(redirectBack));
    } else {
      history.goBack();
    }
  };

  const errors = checkForErrors(formErrors);

  const handleSendReply = () => {
    setFormErrors([]);

    if (!adminReply.trim()) {
      setFormErrors([{ path: 'adminReply', errorMessage: 'Reply is required' }]);
      return;
    }

    sendReply(
      {
        ticketId,
        message: adminReply,
      },
      {
        onSuccess: () => {
          setAdminReply('');
        },
        onError: (err) => {
          if (err?.response?.data?.errors) {
            setValidationErrorServer(err.response.data.errors);
          }
        },
      }
    );
  };

  return (
    <>
      <div className="mainWraper coursetabsection">
        <div className="tab">
          <ul className="tab__menu">
            <li className="back">
              <button className="btn-back" onClick={handleGoBack}>
                <img src={AppPics.BackSvg} alt="Back" />
              </button>
            </li>
          </ul>

          <div className="tab__content ___adjust___tab___padding">
            <div className="tab__content-actHead">
              <AppBreadcrumbs
                links={[
                  { label: 'Dashboard', to: '/dashboard' },
                  { label: 'Support Tickets', to: '/support/tickets' },
                  { label: 'Ticket Details', to: `/support/tickets/${ticketId}` },
                ]}
                current="Reply"
              />
            </div>

            <div className="tab__content-actBody">
              <div className="px-5 py-5">
                <div className="ticket-view">
                  {/* USER ISSUE */}
                  <div className="row mb-4">
                    <div className="col-12">
                      <h2 className="prime-head p-0 boldtitle">User Issue</h2>
                      <p className="prime-head p-0 boldtitle">
                        Issue Type: {ticketData?.issueCategory}
                      </p>
                      <p className="user-message">Message: {ticketData?.message}</p>
                    </div>
                  </div>

                  {/* Replies List */}
                  {replies.length > 0 && (
                    <div className="row mb-4 mt-2">
                      <div className="col-12">
                        <h2 className="prime-head p-0 boldtitle">Replies</h2>

                        {replies.map((reply) => (
                          <div
                            key={reply._id}
                            className="reply-box py-3 px-3 mb-3"
                            style={{ background: '#f8f9fa', borderRadius: '8px' }}
                          >
                            <p className="reply-message mt-2">{reply.message}</p>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* ADMIN REPLY */}
                  <div className="row">
                    <div className="col-12">
                      <h2 className="prime-head p-0 boldtitle">Add Reply</h2>

                      {validationErrorServer && (
                        <ul className="error-list">
                          {Object.values(validationErrorServer).map((err, idx) => (
                            <li key={idx}>{err.msg}</li>
                          ))}
                        </ul>
                      )}

                      <AppTextField
                        labelProps={{ label: 'Reply *', htmlFor: 'admin-reply' }}
                        inputProps={{
                          placeholder: 'Type your reply here...',
                          id: 'admin-reply',
                          name: 'adminReply',
                          value: adminReply,
                          onChange: (e) => setAdminReply(e.target.value),
                          tabIndex: 1,
                          multiline: true,
                        }}
                        fieldErrors={errors.adminReply}
                      />
                      {errors.adminReply && (
                        <div className="text-danger">{errors.adminReply.errorMessage}</div>
                      )}
                    </div>
                  </div>

                  {/* SUBMIT BUTTON */}
                  <div className="d-flex justify-content-end mt-4">
                    <AppButton
                      type="submit"
                      variantClass="btn-primary mx-3"
                      style={{ minWidth: '1.5rem' }}
                      onClick={handleSendReply}
                      disabled={disableSubmit || isLoading}
                      tabIndex={2}
                    >
                      {isLoading ? 'Sending...' : 'Send Reply'}
                    </AppButton>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ManageSupportTicket;
